import { RootState } from './store';
import cloneDeep from 'lodash.clonedeep';

/** A payload whose properties are all optional can be omitted entirely. */
type PayloadArgs<T> = {} extends T ? [payload?: T] : [payload: T];

export function createReducer<S extends RootState = RootState, T extends object = {}>(mutate: (state: S, payload: T) => void) {
  const preparedDispatch = (...args: PayloadArgs<T>) => (state: S) => {
    mutate(state, cloneDeep((args[0] ?? {}) as T));
    return state;
  };
  return preparedDispatch;
}

export function createNilReducer<S extends RootState = RootState>(mutate: (state: S) => void) {
  const preparedDispatch = () => (state: S) => {
    mutate(state);
    return state;
  };
  return preparedDispatch;
}

export function select<T>(state: RootState, selector: (state: RootState) => T) {
  return selector(state);
}

export function dispatch(state: RootState, reducer: (state: RootState) => RootState) {
  return reducer(state);
}

export type PreparedDispatch = (state: RootState) => RootState;
export type PreparedSelector<T extends unknown = unknown> = (state: RootState) => T;
